import { render, staticRenderFns } from "./MyStaff.vue?vue&type=template&id=f3659fec&scoped=true"
import script from "./MyStaff.vue?vue&type=script&lang=js"
export * from "./MyStaff.vue?vue&type=script&lang=js"
import style0 from "./MyStaff.vue?vue&type=style&index=0&id=f3659fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3659fec",
  null
  
)

export default component.exports